const mapOptions = {
    center: [52.392, 16.924],
    zoom: 9,
    doubleClickZoom: false,
    gestureHandling: true,
};

const map = new L.map('map', mapOptions);

const layer = new L.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
map.addLayer(layer);

const customIcon = {
    iconUrl: `${document.location.origin}/wp-content/themes/kzn/dist/images/sim-pin-inactive.svg`,
    iconSize: [40, 40],
    active: false,
};

const activeIcon = {
    iconUrl: `${document.location.origin}/wp-content/themes/kzn/dist/images/sim-pin-active.svg`,
    iconSize: [40, 40],
    active: true,
};

fetch(`${document.location.origin}/wp-json/acf/v3/options/map-markers`)
    .then((jsonData) => jsonData.json())
    .then((data) => loadMarkers(data.acf.markers));

const loadMarkers = (data) => {
    const markers = [];
    data.forEach((item) => {
        markers.push([
            `
            <div class="rounded-[4px] border-x border-y bg-white border-x-[#E6EBF3] border-y-[#E6EBF3] border-solid">
	           <figure class="w-full h-[296px] overflow-hidden">
		          <img class="w-full object-cover" src="${item.image}">
	           </figure>           
	           <div class="p-6">
		          <p class="text-lg text-dark font-semibold" style="margin-bottom:12px!important;">${item.city}</p>
		          <p class="mt-3 text-base leading-relaxed text-dark">${item.description}</p>
		          <div class="h-px bg-lightBig my-7"></div>
		          <a href="${item.link}" class="Button--no-style text-blue_light font-bold text-sm inline-block">Sprawdź szczegóły</a>
	           </div>
            </div>
            `,
            Number(item.x),
            Number(item.y),
        ]);
    });

    const myIcon = L.icon(customIcon);
    const myActiveIcon = L.icon(activeIcon);

    const iconOptions = {
        title: 'Inwestycja SIM',
        draggable: false,
        icon: myIcon,
    };

    for (let i = 0; i < markers.length; i++) {
        marker = new L.marker([markers[i][1], markers[i][2]], iconOptions)
            .on('click', () => {
                if (marker.options.icon.options.active) {
                    marker.setIcon(myIcon);
                } else {
                    marker.setIcon(myActiveIcon);
                }
            })
            .bindPopup(markers[i][0])
            .addTo(map);
        marker.getPopup().on('remove', function () {
            marker.setIcon(myIcon);
        });
    }

    const popup = L.popup().openOn(map);
};
